import { Image } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import Bags from "images/random/bags.svg";
import { transformChunks } from "shared/components/TextWrapper";
import { useCustomToast } from "shared/hooks/useCustomToast";
import { useScan } from "shared/hooks/useScan/useScan";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS, DetailM } from "ui/Typography/Typography";

function ScanJETReweBagModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: (method: string) => void;
}) {
  const { showToastUI } = useCustomToast();
  useScan({
    onScan: (scannedValue: string) => {
      const barcodePattern = /^JET<>REWE([a-zA-Z0-9]+)?$/;
      const isValid = scannedValue && barcodePattern.test(scannedValue);

      if (!isOpen) return;

      if (isValid) {
        onClose("scanned");
        return;
      }

      showToastUI({
        id: "barcode_error_toast_id",
        title: "component.modal.barcode-issue.wrong",
      });
    },
  });

  const handleReport = () => {
    onClose("reported");
  };

  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={() => {}}
      size="xs"
    >
      <Modal.Content marginX="s300">
        <Modal.Body display="flex" flexDir="column" alignItems="center" textAlign="center">
          <Image mt="s200" src={Bags} />
          <HeaderS mt="s200">
            <FormattedMessage id="components.scan-jet-rewe-bag-modal.header" />
          </HeaderS>
          <BodyM mt="s100">
            <FormattedMessage id="components.scan-jet-rewe-bag-modal.body" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer m="auto">
          <DetailM data-testid="scan-jet-rewe-bag-modal-report">
            <FormattedMessage
              id="components.scan-jet-rewe-bag-modal.footer"
              values={transformChunks({
                a: {
                  cursor: "pointer",
                  textDecoration: "underline",
                  onClick: handleReport,
                },
              })}
            />
          </DetailM>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}

export default ScanJETReweBagModal;
